import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface PromotedSportSectionContainerPropsType {
    variant: DefaultComponentVariantType | null;
}

const setPlaceholderWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            background-color: ${theme.star.eventsTableColors.bgColor};
            padding: 0 ${theme.star.padding.medium} ${theme.star.padding.medium};
            display: flex;
            gap: ${theme.star.gap.medium};
            flex-flow: column nowrap;
        `;
    }
    return css``;
};

export const PromotedSportSectionContainer = withConfig(theme => styled('div', { label: 'PromotedSportSectionContainer' })<PromotedSportSectionContainerPropsType>`
    ${({ variant }): SerializedStyles => setPlaceholderWrapper(variant, theme)}
`);

interface CompetitionWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setCompetitionWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.small};
        `;
    }
    return css``;
};

export const CompetitionWrapper = withConfig(theme => styled('div', { label: 'CompetitionWrapper' })<CompetitionWrapperPropsType>`
    ${({ variant }): SerializedStyles => setCompetitionWrapper(variant, theme)}
`);
